export const EVENT_OMID_VIDEO_TRACKING = 'omid_video_tracking';
export const EVENT_OMID_DISPLAY_TRACKING = 'omid_display_tracking';
export const EVENT_OMID_VAST_TRACKING = 'omid_vast_tracking';
export const EVENT_OMID_SDK_ACTIVATED = 'omid_sdk_activated';

const omidTrackingEvents = {
  [EVENT_OMID_VIDEO_TRACKING]: false,
  [EVENT_OMID_DISPLAY_TRACKING]: false,
  [EVENT_OMID_VAST_TRACKING]: false,
  [EVENT_OMID_SDK_ACTIVATED]: false
};

export const setOmidTrackingEvent = (
  omidTrackingEvent: string,
  value: boolean
): void => {
  // eslint-disable-next-line no-prototype-builtins
  if (!omidTrackingEvents.hasOwnProperty(omidTrackingEvent)) {
    return;
  }
  // @ts-ignore
  omidTrackingEvents[omidTrackingEvent] = value;
};

export const getOmidTrackingEvents = () => omidTrackingEvents;
